import React from "react";
import { Link } from "react-router-dom";
import {
  MapPinIcon,
  BriefcaseIcon,
  CalendarDaysIcon,
} from "@heroicons/react/24/outline";

const OptionItem = ({ pos, idx }) => {
  return (
    <div
      key={idx}
      className="group relative flex flex-col justify-between bg-white/70 backdrop-blur-sm ring-1 ring-gray-200 rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300"
    >
      {/* Title */}
      <h2 className="text-2xl font-extrabold text-gray-900 mb-3">
        {pos.titleDisplay}
      </h2>

      {/* Meta */}
      <div className="flex justify-between items-center text-sm text-gray-500 mb-5">
        {/* Left Side: Location and Type */}
        <div className="flex items-center gap-x-6">
          <div className="flex items-center gap-x-1">
            <MapPinIcon className="w-4 h-4 text-gray-400" />
            <span>{pos.location}</span>
          </div>
          <div className="flex items-center gap-x-1">
            <BriefcaseIcon className="w-4 h-4 text-gray-400" />
            <span>{pos.type}</span>
          </div>
        </div>

        {/* Right Side: Last Date with Blinking */}
        <div className="flex items-center gap-x-1 blink">
          <CalendarDaysIcon className="w-4 h-4 text-red-500" />
          <span className="text-red-600 font-semibold">
            Last Date: {pos.lastDate}
          </span>
        </div>
      </div>

      {/* Tags */}
      <div className="flex flex-wrap gap-2 mb-4">
        {pos.tags.map((tag, index) => (
          <span
            key={index}
            className="inline-block bg-blue-50 text-blue-800 text-xs font-medium px-3 py-1 rounded-full"
          >
            {tag}
          </span>
        ))}
      </div>

      {/* Description */}
      <p className="text-gray-600 text-[15px] leading-relaxed mb-6 ">
        {pos.description}
      </p>

      {/* Requirements */}

      <div className="mb-8 w-full">
        <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
          Requirements
        </h3>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
          {pos.requirements.map((req, i) => (
            <li key={i} className="text-start">
              {req}
            </li>
          ))}
        </ul>
      </div>

      {/* CTA */}
      <div className="mt-auto pt-4">
        <Link to={`/careers/${pos.id}/${decodeURIComponent(pos.title)}`}>
          <button className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white text-sm font-semibold py-3 rounded-lg transition-all duration-200 group-hover:scale-[1.02]">
            Apply Now →
          </button>
        </Link>
      </div>
    </div>
  );
};

export default OptionItem;
